import { Outlet, useNavigate } from "react-router";
import SessionPopupWrapper from "../../providers/NetworkProvider";
import { useEffect } from "react";

const NoLayout = () => {
  return (
    <>
      <SessionPopupWrapper>
        <Outlet />
      </SessionPopupWrapper>
    </>
  );
};

export default NoLayout;
